import React from 'react'

const Employees = () => {
  return (
    <div>Employees</div>
  )
}

export default Employees